import FqApi from '@/services/fq-api'

export default {
  async getNewEntity() {
    const url = '/quotes/remarks/new'
    const result = await FqApi.get(url)
    return result.data
  },
  async getRemarkEntities(quoteId, remarkType) {
      const url = `/quotes/remarks/list/${quoteId}/${remarkType}`
    const result = await FqApi.get(url)
    return result.data
  },
  async postEntity(entity) {
    return FqApi.post('/quotes/remarks', entity)
  },
  async putEntity(entity) {
    return FqApi.put(`/quotes/remarks/${entity.remarkId}`, entity)
  },
  async deleteEntity(remarkId) {
    return FqApi.delete(`/quotes/remarks/${remarkId}`)
  },
  async getUnreadCount(quoteId) {
    const result = await FqApi.get(`/quotes/remarks/unreadcount/${quoteId}`)
    return result.data
  },
  async setRemarksAsRead(quoteId) {
    const result = await FqApi.post(`/quotes/remarks/setasread/${quoteId}`)
    return result.data
  }
}
